export default __webpack_public_path__ + "static/media/HomeBg.8c078d3d.png";